import { useState, useEffect } from "react";
export const FIRing = ({ progress, size = 120, c }) => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => { const t = setTimeout(() => setMounted(true), 100); return () => clearTimeout(t); }, []);
  const r = (size - 12) / 2;
  const circumference = 2 * Math.PI * r;
  const p = Math.min(100, Math.max(0, progress));
  const offset = circumference - ((mounted ? p : 0) / 100) * circumference;
  const color = p >= 100 ? c.green : p >= 60 ? c.blue : c.orange;
  return (
    <div style={{ position: "relative", width: size, height: size, flexShrink: 0 }} role="img" aria-label={"Financial independence progress: " + Math.round(p) + "%"}>
      <svg width={size} height={size} style={{ transform: "rotate(-90deg)" }}>
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={c.border} strokeWidth={6} />
        <circle cx={size / 2} cy={size / 2} r={r} fill="none"
          stroke={color} strokeWidth={6} strokeLinecap="round"
          strokeDasharray={circumference} strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 1.2s cubic-bezier(0.25,0.1,0.25,1), stroke 0.3s" }} />
      </svg>
      <div style={{
        position: "absolute", inset: 0, display: "flex", flexDirection: "column",
        alignItems: "center", justifyContent: "center",
      }}>
        <div style={{ fontSize: 22, fontWeight: 700, color: c.fg, letterSpacing: "-0.03em" }}>{Math.round(p)}%</div>
        <div style={{ fontSize: 9, color: c.muted, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.08em" }}>to FI</div>
      </div>
    </div>
  );
};
